<div class="modal-header customBlueHeader">
  <p class="modal-title" *ngIf="sendPaymentLink">Confirm Contact Number</p>
  <p class="modal-title" *ngIf="generateReceipt">Generate Receipt</p>
  <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  <button type="button" class="close" aria-label="Close" (click)="modelClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body customModalBody" *ngIf="sendPaymentLink">
  <form [formGroup]="otp_Form">
    <div>

      <div class="form-group">
        <label>Contact Number<sup>*</sup></label>
        <input type="text" class="form-control" id="" formControlName="mobilenumber" (keypress)="OnlyNumeric($event)">
        <div class="text-danger" *ngIf="otp_Form.get('mobilenumber').hasError('required')">
          filed required !
         </div>
      </div>
      <div class="form-group">
        <label>Contact Email<sup>*</sup></label>
        <input type="text" class="form-control" id="" formControlName="email" >
        <div class="text-danger" *ngIf="otp_Form.get('mobilenumber').hasError('required')">
          filed required !
         </div>
      </div>
      <div class="form-group" *ngIf="isCareAthome">
        <label>No Of Session<sup>*</sup></label>
        <input type="text" class="form-control" id="" formControlName="sections" (change)="payableAmont()" (keypress)="OnlyNumeric($event)">
        <div class="text-danger" *ngIf="otp_Form.get('sections').hasError('maxValue')">
          Value must be less than or equal to {{noOfSections}}.
        </div>
        <div class="text-danger" *ngIf="otp_Form.get('sections').hasError('required')">
         filed required !
        </div>
      </div>
      <div class="form-group" *ngIf="isCareAthome">
        <label>Payable amount for<span class="text-danger"> {{otp_Form.value.sections}}</span> Session<sup>*</sup></label>
        <input type="text" class="form-control" id="" formControlName="payableAmont" disabled>
        <!-- <div class="text-danger" *ngIf="otp_Form.get('sections').hasError('maxValue')">
          Value must be less than or equal to {{noOfSections}}.
        </div> -->
      </div>

    </div>
    <div class="modal-footer customModalFooter bdr-none">
      <button type="button" class="btn green_btn" (click)="submitPaymentLinkData()" [disabled]="otp_Form.invalid">Submit</button>
    </div>
  </form>


</div>


<div class="modal-body customModalBody" *ngIf="generateReceipt">
  <form [formGroup]="receipt_Form">
    <div>
      <div class="form-group">
        <label>Payment Mode<sup>*</sup></label>
       <!-- <select size="1" name="search_type" id="recipt_modal_select" onchange="selectpaymentmodeype()" formControlName="paymentMode"
       class="submitrecipt btn dropdown-toggle select_search_value form-control pull-left" 
       aria-controls="example" style="background-color: #7BAE4D; color: #FFFFFF;height:33px;"> -->
       <select size="1" name="search_type" id="recipt_modal_select" onchange="selectpaymentmodeype()" formControlName="paymentMode"
       class="form-control" 
       aria-controls="example" >
       <option value="" disabled>Select</option>
       <option value="cash">Cash</option>
        <option value="Cheque">Cheque</option>
        <option value="UPI">UPI</option>
        <option value="Other">Other</option>
      </select>
        </div>
        <div class="form-group" *ngIf="isCareAthome">
          <label>No Of Session<sup>*</sup></label>
          <input type="text" class="form-control" id="" formControlName="sections" (change)="payableAmont()" (keypress)="OnlyNumeric($event)">
          <div class="text-danger" *ngIf="receipt_Form.get('sections').hasError('maxValue')">
            Value must be less than or equal to {{noOfSections}}.
          </div>
        </div>
        <div class="form-group" *ngIf="isCareAthome">
          <label>Payable amount for<span class="text-danger"> {{receipt_Form.value.sections}}</span> Session<sup>*</sup></label>
          <input type="text" class="form-control" id="" formControlName="amount" disabled>
          <!-- <div class="text-danger" *ngIf="otp_Form.get('sections').hasError('maxValue')">
            Value must be less than or equal to {{noOfSections}}.
          </div> -->
        </div>
      </div>
      <div class="form-group" *ngIf="!isCareAthome">
        <label>Amount<sup>*</sup></label>
        <input type="text" class="form-control" id="" formControlName="amount" (keypress)="OnlyNumeric($event)">
      </div>
      <div class="form-group">
        <label>Payment RefNo<sup>*</sup></label>
        <input type="text" class="form-control" id="" formControlName="paymentRefNo" >
      </div>
      <div class="form-group">
        <label>Payment Date<sup>*</sup></label>
        <input type="text" class="form-control readOnlyActive"  formControlName="date"  placeholder="Payment Date" [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }" bsDatepicker readonly>
      </div>
      <div class="form-group">
        <label>Upload Documents</label>
        <input type="file" class="form-control"  formControlName="fileupload" (change)="uploadReports($event)">
      </div>
      <div class="form-group">
        <label>Reason</label>
        <input type="text" class="form-control" id="" formControlName="reason" >
      </div>
    <div class="modal-footer customModalFooter bdr-none">
      <button type="button" class="btn green_btn" (click)="submitGenerateReceipt()" [disabled]="receipt_Form.invalid" >Submit</button>
    </div>
  </form>


</div>